import { render, staticRenderFns } from "./ProgramCategories.vue?vue&type=template&id=eb80cc6c"
import script from "./ProgramCategories.vue?vue&type=script&lang=js"
export * from "./ProgramCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports